export const VERSION = 'v1.2';
export const appName = '188LUX';
